import request from '@/utils/request'

export function getboards(data) {
  return request({
    url: 'get/devices',
    method: 'post',
    params: data
  })
}
//{"board_id":"xxxx", "coins":"xxx", "downmsg":"raw json if needed"}
export function testCoins(data) {
  return request({
    url: 'test/device/downmsg',
    method: 'post',
    params: data
  })
}

export function pushDeviceFotaUpgrade(data) {
  return request({
    url: 'push/device/fota',
    method: 'post',
    params: data
  })
}

export function getDeviceUartConfig(data) {
  return request({
    url: 'device/uart/config/get',
    method: 'post',
    params: data
  })
}

export function setDeviceUartConfig(data) {
  return request({
    url: 'device/uart/config/set',
    method: 'post',
    params: data
  })
}
